import { DZ_COLOR_YELLOW_400 } from '@blk/daisy/core/styles';
import { AbstractRenderer, Alignment, BusinessComponent, BusinessComponentOptions, ColumnPanel, ImageRenderer, RowPanel, SquareRenderer, StaticParagraphComponent } from '@blk/simba';
import { HeadingComponent, HeadingLevel } from '@ddt-web/pdf-components';

import { PdfImages } from '../static';
import { investmentGuidingPrinciples } from './investment-guiding-principles-dcr';


export class InvestmentGuidingPrinciples extends BusinessComponent {

	constructor(name: string, public modelsType: string, public visible: boolean = true) {
		super(name, 'BusinessComponent', BusinessComponentOptions.merge({ visible: visible }));
	}

	public buildComponent(): AbstractRenderer<SVGGElement>[] {
		const panels: AbstractRenderer<SVGGElement>[] = [];

		panels.push(
			new RowPanel('Investment Process Heading', [new HeadingComponent('INVESTMENT_GUIDING_PRINCIPLES_HEADER', 'INVESTMENT GUIDING PRINCIPLES', HeadingLevel.H1)],
				{ marginBottom: 32 }, Alignment.Horizontal.Left, Alignment.Vertical.Top),
			this.buildBodyPanel()
		);
		return panels;
	}

	private buildBodyPanel(): RowPanel {
		const panel: RowPanel = new RowPanel('Investment Guiding Principles Body', [
			new ColumnPanel('Left Image Section', [
				new ImageRenderer(PdfImages.INVESTMENT_GUIDING_PRINCIPLES_IMG, { height: 302, width: 226, paddingLeft: 0 })
			], { proportion: 35 }),
			new ColumnPanel('Right Points Section', [
				...this.buildPrinciplesSection()
			], { proportion: 65 })
		], {}, Alignment.Horizontal.Left, Alignment.Vertical.Top);
		return panel;
	}

	private buildPrinciplesSection(): RowPanel[] {
		const panels: ColumnPanel[] = [];
		const principleRowPanels: RowPanel[] = [];

		investmentGuidingPrinciples.forEach((point, index) => {

			panels.push(new ColumnPanel(`Investment principle - ${index + 1}`, [
				new SquareRenderer(DZ_COLOR_YELLOW_400, { marginBottom: 8 }, 9, 9),
				new StaticParagraphComponent(`${point.principle.dcrKey}${this.modelsType ? '_' + this.modelsType.toLocaleUpperCase() : ''}`,
					point.principle.dcrValue, {}, { marginBottom: 8 }, ['text-extra-bold', 'text-16']),
				new StaticParagraphComponent(`${point.description.dcrKey}${this.modelsType ? '_' + this.modelsType.toLocaleUpperCase() : ''}`,
					point.description.dcrValue, {}, {}, ['text-9'])
			], { proportion: 50, paddingRight: 36, marginBottom: 20 }, Alignment.Horizontal.Left));

		});

		for (let i = 0; i < panels.length; i = i + 2) {
			principleRowPanels.push(new RowPanel('Investment principle row', panels.slice(i, i + 2)));
		}

		return principleRowPanels;
	}
}
